import { Component  } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { OpcionModel } from '../Global/Opcion.model';
import { ResolucionModel } from './Resolucion.model';
import { MchResolucionesModel } from '../Prefijo/MchResoluciones.model';
import { MchResolucionesId } from '../Prefijo/MchResoluciones.model';
import { addMonths } from 'date-fns';



@Component({
	selector : 'ResolucionEdit',
	templateUrl : './ResolucionEdit.component.html',
	styleUrls  : ['../../../../styles.css']

})

export class ResolucionEditComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //



	public resolucion:MchResolucionesModel;


	public displayedColumns;
	public dataSource;
	public ocultar: boolean = false;
	

	myControl = new FormControl();


	public cnumcont:string;
	public cprefijo:string;
	
	public picker2:any;

	public form: FormGroup;
	public formErrors: any;

	public mensaje: string = "";

	public cantidad: number = 0;


	constructor(private _serviciosGenerales:ServiciosGenerales,
		public snackBar: MatSnackBar,
		private _router:Router,
		private _route: ActivatedRoute,private formBuilder: FormBuilder ){

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.formErrors = {

			ndesde : {},
			nhasta : {},
			nmesesresolucion : {},
			dfechaexpedicion : {},
			dfechavencimiento : {}
			
		};

		this._route.params.subscribe( params =>{
			this.cnumcont = params['cnumcont'];
			this.cprefijo = params['cprefijo'];
		});


	}


	ngOnInit(){

		

		this.form = this.formBuilder.group({
			ndesde : [0,[Validators.required, Validators.max(999999999), Validators.min(1)]],
			nhasta : [0,[Validators.required, Validators.max(999999999), Validators.min(1)]],
			nmesesresolucion : ['', [Validators.required, Validators.max(999), Validators.min(1)]],
			dfechaexpedicion : ['', Validators.required],
			dfechavencimiento : [{value:new Date(), disabled : true}, Validators.required],

		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});

		this.resolucion = new MchResolucionesModel(new MchResolucionesId(this.cnumcont, this.cprefijo, 0), '', 0, 0, 0, new Date(), new Date());

		this.consultarCantidad(this.cprefijo);
	}


	addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
		this.completarFecha();
	}


	consultarCantidad(prefijo: string): void {
		
	this._serviciosGenerales.get('consultarDocumentosPendientes', { prefijo:prefijo })
		.subscribe(
			(res: any) => {
				console.log("res "+res)
				console.log('Cantidad:', res[0].CANTIDAD);
				// Aquí puedes usar la cantidad, o guardarla en una propiedad del componente
				this.cantidad = res[0].CANTIDAD;
			},
			(error: any) => {
				console.error('Error al consultar:', error);
				this.cantidad = 0;
			}
		);

}

	guardar(){
    
		var regex = new RegExp(/^[0-9]*$/);
		//console.log(this.resolucion.ndesde , ' <-> ', this.resolucion.nhasta, ' <--> ',(this.resolucion.ndesde == this.resolucion.nhasta));
		if (regex.test(this.resolucion.vresolucion) == false   ||  this.resolucion.vresolucion.indexOf(' ') > -1  ||  this.resolucion.vresolucion == null  ||  this.resolucion.vresolucion.length ==0 )
	 {
			this.openSnackBarEspecial('La resolución no es valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras  entrando', 'X' );
			return;  
		}  
		
		this.consultarCantidad(this.cprefijo);
		
		if(this.cantidad > 0){
			this.openSnackBarEspecial("No se puede guardar la resolución, ya que existen documentos pendientes.", "X");
			return;
		}


		if(this.form.valid == false){
			this.openSnackBarEspecial("Los datos del formulario no son válidos, por favor verificar", "X");
			return;
		} 
		if(this.resolucion.ndesde > this.resolucion.nhasta){
			this.openSnackBarEspecial("El valor del campo 'Desde' no puede ser mayor al del campo 'Hasta'", "X");
			return;
		}
		//if(this.resolucion.ndesde == this.resolucion.nhasta){
		//	this.openSnackBarEspecial("El valor del campo 'Desde' no puede ser igual al del campo 'Hasta'", "X");
		//	return;
		//}

		this.ocultar = true;
		this._serviciosGenerales.post('guardar/resolucion', this.resolucion).subscribe(
			result=>{
				
				if(result.error == false){
					this._router.navigate(['/Resolucion', this.cnumcont, this.cprefijo]);
					this.openSnackBar(result.mensaje, "X")
				}else{
					this.openSnackBarEspecial(result.mensaje, "X")
				}
				
			}, error=>{
				this.openSnackBarEspecial("Ocurrió un error mientras se guarda la resolución", "X");
				console.log(error, '');
			})
	}

	bloquearBoton(){
		var count = 1;
		this.guardar()
	}

	completarFecha(){
		var temp = this.resolucion.nmesesresolucion;
		if(temp == null)
			temp = 0;
		/*else if(temp < 0){
			this.resolucion.nmesesresolucion = 0;
			this.completarFecha();
			return;
		}
		else
			temp = temp - 1;
		var result = new Date(this.resolucion.dfechaexpedicion);*/
		//result.setMonth(result.getMonth() + temp);
		//this.resolucion.dfechavencimiento = new Date(result.getFullYear(), (result.getMonth()+1), result.getDate());
		this.resolucion.dfechavencimiento=addMonths(this.resolucion.dfechaexpedicion, temp);
	}


	onFormValuesChanged()
	{
		for ( const field in this.formErrors )
		{
			if ( !this.formErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}



}


export class ExampleDataSource {

	public data: Array<ResolucionModel>;
	

	constructor(tercero:Array<ResolucionModel>){
		this.data = new Array();
		
		
		if(tercero != null){
			for(let i of tercero){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ResolucionModel[]>
	{
		return Observable.of(this.data);
	}

	disconnect(){}
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Resoluciones/ResolucionEdit.component.ts